const getAvailableIconName = (placeType?: PlaceType) => {
  switch (placeType) {
    case 'city':
      return 'pin-city';

    case 'town':
      return 'pin-town';

    case 'village':
      return 'pin-village';

    case 'island':
      return 'pin-island';

    case 'natureReserve':
    case 'nationalPark':
      return 'pin-nature';

    case 'peak':
      return 'pin-peak';

    default:
      return 'pin-other';
  }
};

export const placesToFeatureCollection = (places: Partial<Place>[]): any => {
  return {
    type: 'FeatureCollection',
    features: places
      .filter((place) => place?.location?.coordinates)
      .map((place, i) => ({
        id: i,
        type: 'Feature',
        properties: {
          id: place._id,
          placeId: place._id,
          name: place.name,
          icon: getAvailableIconName(place.placeType as PlaceType)
        },
        geometry: {
          type: 'Point',
          coordinates: place.location?.coordinates || [0, 0]
        }
      }))
  };
};
